export default "__VITE_ASSET__DlVoNRHB__"